import { EditMap, Timepoint, NoteType } from "../MappingScope/EditMap";
import { entryList, assert } from "../Common/utils";
import { Music } from "../MappingPage/states";
import { NoteBase } from "bangbangboom-game/build/Core/RawMap";
import { Meta } from "../MappingScope/Meta";

type NoteData = {
  LaneId: number;
  Time: number;
};

type HachimiChartData = {
  BarLineList: number[];
  NoteDataList: NoteData[];
};

// thanks maomao
export function toHachimiFormat(map: EditMap, meta: Meta): string {
  const len = Music.duration;

  const chartData: HachimiChartData = {
    BarLineList: [],
    NoteDataList: [],
  };

  const tps: Timepoint[] = Array.from(map.timepoints.values())
    .sort((a, b) => a.time - b.time);

  {
    const [tp] = tps;

    if (!tp) {
      throw new Error('谱都没写你导个蛋')
    }
    const tpb = 60 / (tp.bpm / tp.bpb);

    chartData.BarLineList.push(tp.time);
    chartData.BarLineList.push(tp.time + tpb);
  }

  const chartNotes = Array.from(map.notes.values()).sort(
    (a: NoteType, b: NoteType) => {
      return a.offset - b.offset;
    }
  );

  chartNotes.forEach((note) => {
    const tp = assert(map.timepoints.get(note.timepoint));
    const tpOffset = 60 / (tp.bpm * 48);

    const time = tp.time + note.offset * tpOffset;
    const hachimiNote: NoteData = {
      LaneId: note.lane,
      Time: time,
    };

    chartData.NoteDataList.push(hachimiNote);
  });

  chartData.NoteDataList.sort((a, b) => a.Time - b.Time);

  if (meta.name.includes("\"") || meta.name.includes("'")) {
    throw new Error("曲名内不允许使用 \" 或者 ' ");
  }

  if (meta.chartName.includes("\"") || meta.chartName.includes("'")) {
    throw new Error("谱名内不允许使用 \" 或者 ' ");
  }

  const instructions = [
    ["Begin"],
    ["SetName", meta.name],
    ["SetCharter", meta.chartName],
    ["SetSoundEvent", "music.dummy_music"],
    ["SetCover", "1"],
    ["SetBarLines", JSON.stringify([parseFloat(chartData.BarLineList[0].toFixed(2)), parseFloat(chartData.BarLineList[1].toFixed(2))])],
    ...chartData.NoteDataList.map(note => ["AddNote", JSON.stringify([note.LaneId, parseFloat(note.Time.toFixed(2))])]),
    ["End"],
  ]

  for (let i = 500; i < instructions.length; i += 500) {
    if (instructions[i][0] === "End")
      break;

    instructions.splice(i, 0, ["Next"]);
  }

  const lines = [
    '// auto generated by bbb editor',
    ...instructions.map(inst => {
      const [cmd, arg] = inst;
      if (arg) {
        return `ent_fire pulseent ScrIns "${cmd}|${arg}"`;
      }

      if (cmd === "Next") {
        return `ent_fire pulseent ScrIns "Next"\n// ----- next file -----\n\n`;
      }

      return `ent_fire pulseent ScrIns "${cmd}"`;
    }),
    '',
  ];

  return lines.join('\n');
}
